// @ts-nocheck
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { APP_COLORS as C, APP_FONT as F } from '../pages/Dashboard/tokens';

/**
 * ReportsLayout: secondary sidebar on the left + <Outlet /> for the active
 * report page on the right. Wraps every /reports/* route.
 */

type NavChild = { label: string; path: string };
type NavItem  = { label: string; path?: string; children?: NavChild[] };

const NAV: NavItem[] = [
  {
    label: 'Financial planning',
    children: [
      { label: 'Cash flow overview', path: '/reports/planning/cash-flow-overview' },
      { label: 'Cash flow planner',  path: '/reports/planning/cash-flow-planner'  },
      { label: 'Budgets',            path: '/reports/planning/budgets'            },
    ],
  },
  { label: 'Management reports', path: '/reports/management' },
  { label: 'Standard reports',   path: '/reports'            },
  { label: 'Custom reports',     path: '/reports/custom'     },
];

export default function ReportsLayout(): React.ReactElement {
  const location = useLocation();
  const navigate = useNavigate();
  const current  = location.pathname;

  const isActive = (p?: string): boolean => {
    if (!p) return false;
    if (p === '/reports') return current === '/reports';
    return current === p;
  };
  const groupHasActive = (item: NavItem): boolean =>
    Array.isArray(item.children) && item.children.some(c => isActive(c.path));

  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - 90px)', fontFamily: F.family, background: '#fff', borderRadius: 12, border: '1px solid ' + C.line, overflow: 'hidden' }}>
      <aside style={{ width: 220, borderRight: '1px solid ' + C.line, padding: '16px 10px', background: '#FAFBFC', flexShrink: 0, overflowY: 'auto' }}>
        <div style={{ fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', fontWeight: 800, color: '#475569', padding: '0 10px 10px', whiteSpace: 'nowrap' }}>
          Reports &amp; Analytics
        </div>
        {NAV.map((item) => {
          if (item.children) {
            const open = groupHasActive(item);
            return (
              <div key={item.label} style={{ marginBottom: 2 }}>
                <div style={{ padding: '7px 10px', fontSize: 12.5, fontWeight: 600, color: C.ink, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: 6, cursor: 'default' }}>
                  <span>{item.label}</span>
                  <span style={{ fontSize: 10, color: '#CBD5E1', transform: open ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.15s' }}>&rsaquo;</span>
                </div>
                <div style={{ paddingLeft: 10, marginTop: 2 }}>
                  {item.children.map((c) => {
                    const active = isActive(c.path);
                    return (
                      <div
                        key={c.path}
                        onClick={() => navigate(c.path)}
                        style={{ padding: '6px 10px 6px 20px', fontSize: 12.5, color: C.ink, borderRadius: 6, cursor: 'pointer', marginBottom: 1, background: active ? '#E7EAF0' : 'transparent', fontWeight: active ? 700 : 500 }}
                        onMouseEnter={(e) => { if (!active) (e.currentTarget as HTMLDivElement).style.background = '#F1F5F9'; }}
                        onMouseLeave={(e) => { if (!active) (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
                      >
                        {c.label}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }
          const active = isActive(item.path);
          return (
            <div
              key={item.label}
              onClick={() => item.path && navigate(item.path)}
              style={{ padding: '7px 10px', fontSize: 12.5, color: C.ink, borderRadius: 6, cursor: 'pointer', marginBottom: 1, background: active ? '#E7EAF0' : 'transparent', fontWeight: active ? 700 : 500 }}
              onMouseEnter={(e) => { if (!active) (e.currentTarget as HTMLDivElement).style.background = '#F1F5F9'; }}
              onMouseLeave={(e) => { if (!active) (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
            >
              {item.label}
            </div>
          );
        })}
      </aside>

      <main style={{ flex: 1, padding: '20px 24px', overflowY: 'auto', minWidth: 0 }}>
        <Outlet />
      </main>
    </div>
  );
}
